import React, { useContext } from 'react';

export interface ExperimentsData {
    experiments: string;
}

const experimentsContext = React.createContext<ExperimentsData>({ experiments: '' });

export const ExperimentsProvider = experimentsContext.Provider;
export const ExperimentsConsumer = experimentsContext.Consumer;

function useExperiments(): ExperimentsData {
    const context = useContext(experimentsContext);

    if (context === undefined) {
        throw new Error('useExperiments must be used within a ExperimentsProvider');
    }

    return context;
}

export function useIsExperimentActivated(name: string, variant: string, version?: string): boolean {
    const { experiments } = useExperiments();

    const experimentsArray = experiments.split(';');
    const matchingExperiments = experimentsArray.filter((experimentString) => {
        const parts = experimentString.trim().split(':');
        if (parts.length !== 3) {
            return false;
        }
        return parts[0] === name && parts[1] === variant && (version ? parts[2] === version : true);
    });

    return matchingExperiments.length > 0;
}
